import React from 'react';
import "./NotFound.scss";
import logo from "../../images/logo.png";
import { useHistory } from 'react-router-dom';

const NotFound = () => {
    const history = useHistory();
    return (
        <>
        <div className="every">
             <div className="imgo"> <img src={logo} alt="logo" /></div>
             <div className="h3p">OUPS !! LA PAGE QUE VOUS CHERCHEZ SEMBLE INTROUVABLE... </div>
             <div className="h3p">ERREUR 404 </div>
             <div className="buttoninscritgjk" onClick={()=>history.push("/")}>RENTRER A L'ACCUEIL</div>
             </div>
        </>
    )
}

export default NotFound
